<template>
  <div class="container mb-3" data-aos="fade-up">
    <div class="row">
      <div class="col-md-3">
        <!-- Usando o FilterComponent -->
        <FilterComponent
          :cities="cities"
          :colors="colors"
          :priceRange="priceRange"
          :yearRange="yearRange"
          :options="options"
          :initialFilters="filters"
          @update-filters="applyFilters"
        />
      </div>

      <div class="col-md-9">
        <h2><i class="fa-solid fa-star"></i> Destaques - <span class="text-uppercase">{{ state }}</span></h2>

        <div class="row gy-3 mb-3">
          <div class="col-6 col-md-3" v-for="announcement in filteredAnnouncements" :key="announcement.id">
            <AnnouncementCard :announcement="announcement" />
          </div>
        </div>

        <div class="row">
          <div class="d-flex justify-content-end">
            <a href="#" class="btn btn-primary" role="button" data-bs-toggle="button">
              Todos <i class="fa-solid fa-arrow-right-to-bracket"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue';
import { useAnnouncementStore } from "@/stores/announcementStore";
import AnnouncementCard from "@/components/AnnouncementCard.vue";
import FilterComponent from "@/components/FilterComponent.vue";

export default {
  props: ['state'],
  components: {
    AnnouncementCard,
    FilterComponent
  },
  setup(props) {
    const announcementStore = useAnnouncementStore();
    const announcements = ref([]);
    const filters = ref({
      category: "",
      year: "",
      state: props.state || "",
      city: "",
      color: "",
      price: "",
      options: []
    });

    // Dados para filtros (obtidos da API)
    const cities = ref([]);
    const colors = ref([]);
    const priceRange = ref([]);
    const yearRange = ref([]);
    const options = ref([]);

    // Função para carregar os anúncios e dados de filtro
    const loadAnuncios = async () => {
      await announcementStore.getStateAnnouncement(props.state, filters.value);
      announcements.value = announcementStore.announcements;
      // Preencher as opções de filtro
      const filtersData = announcementStore.filtersData;
      cities.value = filtersData.cities;
      colors.value = filtersData.colors;
      priceRange.value = filtersData.priceRange;
      yearRange.value = filtersData.yearRange;
      options.value = filtersData.options;
    };

    onMounted(loadAnuncios);

    watch(() => props.state, () => loadAnuncios());

    // Computed para aplicar os filtros nos anúncios
    const filteredAnnouncements = computed(() => {
      return announcements.value.filter((announcement) => {
        return (
          (filters.value.category ? announcement.category === filters.value.category : true) &&
          (filters.value.year ? announcement.year === filters.value.year : true) &&
          (filters.value.state ? announcement.state === filters.value.state : true) &&
          (filters.value.city ? announcement.city === filters.value.city : true) &&
          (filters.value.color ? announcement.color === filters.value.color : true) &&
          (filters.value.price ? announcement.price === filters.value.price : true) &&
          (filters.value.options.length ? filters.value.options.every(option => announcement.options.includes(option)) : true)
        );
      });
    });

    // Função para aplicar os filtros
    const applyFilters = (newFilters) => {
      filters.value = newFilters;
      loadAnuncios();
    };

    return { announcements, cities, colors, priceRange, yearRange, options, filters, filteredAnnouncements, applyFilters };
  }
};
</script>
